import { z } from "zod/v4";
export * from "./cancel-upgrade-preparation";
export * from "./cancel-downgrade-preparation";
export * from "./prepare-downgrade";
export * from "./prepare-upgrade";
export * from "./resolve-recovery";
import {
  MarketShippingConfigurationSchema,
  MarketShippingSummarySchema,
  ShippingCapabilitiesSchema,
} from "../../dtos/market-shipping-configuration";
import { MarketGidSchema } from "../../dtos/shopify-shipping";

export const GetShippingConfigurationRequestQueryParamsSchema = z.object({
  first: z.coerce.number().int().min(1).max(50).default(20),
  after: z.string().optional(),
  marketId: MarketGidSchema.optional(),
  profileId: z.string().optional(),
  groupId: z.string().optional(),
  zoneId: z.string().optional(),
});

export type GetShippingConfigurationRequestQueryParamsType = z.infer<
  typeof GetShippingConfigurationRequestQueryParamsSchema
>;

const configurationFields = {
  capabilities: ShippingCapabilitiesSchema,
  markets: z.array(MarketShippingSummarySchema),
  market: MarketShippingConfigurationSchema.nullable(),
  pageInfo: z.object({
    hasNextPage: z.boolean(),
    endCursor: z.string().nullable(),
  }),
};

export const GetShippingConfigurationResponseBodySchema = z.discriminatedUnion(
  "shippingModel",
  [
    z.object({
      ...configurationFields,
      shippingModel: z.literal("legacy"),
      legacy: z.json().nullable(),
    }),
    z.object({
      ...configurationFields,
      shippingModel: z.literal("markets"),
      legacy: z.null(),
    }),
  ]
);

export type GetShippingConfigurationResponseBodyType = z.infer<
  typeof GetShippingConfigurationResponseBodySchema
>;
